import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_MAT_SECCIONES = 'ALL_MAT_SECCIONES';
export const ACTIVO_MAT_SECCIONES = 'ACTIVO_MAT_SECCIONES';
export const LOADING_ALL_MAT_SECCIONES = 'LOADING_ALL_MAT_SECCIONES';
export const PARAMS_MAT_SECCIONES = 'PARAMS_MAT_SECCIONES';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const matSeccionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MAT_SECCIONES:
      return {
        ...state,
        all: action.payload,
      };
    case ACTIVO_MAT_SECCIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_MAT_SECCIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_MAT_SECCIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
